import React, { useState } from "react";
import { Button, Drawer, Popconfirm } from "antd";
import { useSelector } from "react-redux";
import "./Popconfirm.css";

const getOpenValue = (open, visible) => {
  if (open !== undefined) return open;
  return visible;
};

const ResponsivePopconfirm = ({
  title,
  description,
  children,
  onConfirm,
  onCancel,
  okText = "Yes",
  cancelText = "No",
  okButtonProps = {},
  cancelButtonProps = {},
  open,
  visible,
  disabled,
  className = "",
  overlayClassName,
  zIndex,
  placement,
  ...rest
}) => {
  const isPC = useSelector((state) => state.App?.isPC ?? true);
  const [innerOpen, setInnerOpen] = useState(false);
  const controlledOpen = getOpenValue(open, visible);
  const isControlled = controlledOpen !== undefined;
  const isOpen = isControlled ? controlledOpen : innerOpen;

  const setOpen = (nextOpen) => {
    if (!isControlled) setInnerOpen(nextOpen);
  };

  const handleOpen = (event) => {
    if (disabled) return;
    children?.props?.onClick?.(event);
    if (event?.defaultPrevented) return;
    setOpen(true);
  };

  const handleCancel = (event) => {
    onCancel?.(event);
    setOpen(false);
  };

  const handleConfirm = async (event) => {
    await onConfirm?.(event);
    setOpen(false);
  };

  if (isPC) {
    return (
      <Popconfirm
        {...rest}
        title={title}
        description={description}
        onConfirm={onConfirm}
        onCancel={onCancel}
        okText={okText}
        cancelText={cancelText}
        okButtonProps={okButtonProps}
        cancelButtonProps={cancelButtonProps}
        open={open}
        visible={visible}
        disabled={disabled}
        overlayClassName={overlayClassName}
        zIndex={zIndex}
        placement={placement}
      >
        {children}
      </Popconfirm>
    );
  }

  const trigger = React.isValidElement(children)
    ? React.cloneElement(children, {
        onClick: handleOpen,
      })
    : children;

  return (
    <>
      {trigger}
      <Drawer
        open={isOpen}
        visible={isOpen}
        title={title}
        placement="bottom"
        height="auto"
        onClose={handleCancel}
        zIndex={zIndex}
        className={`responsive-popconfirm-drawer ${className || ""}`}
        destroyOnClose
      >
        {description ? (
          <div className="responsive-popconfirm-drawer__description">
            {description}
          </div>
        ) : null}
        <div className="responsive-popconfirm-drawer__footer">
          <Button {...cancelButtonProps} onClick={handleCancel}>
            {cancelText}
          </Button>
          <Button
            type="primary"
            danger={okButtonProps.danger}
            {...okButtonProps}
            onClick={handleConfirm}
          >
            {okText}
          </Button>
        </div>
      </Drawer>
    </>
  );
};

export default ResponsivePopconfirm;
